import { CreditApprovalStepType } from '@indigo-ag/schema';
import { RoleNames } from './permission';

export const ROLE_TO_STEP_TYPE: Partial<Record<RoleNames, CreditApprovalStepType>> = {
  [RoleNames.FINANCING_ADMIN_BR_CREDIT]: CreditApprovalStepType.CREDIT_ANALYST_APPROVAL,
  [RoleNames.FINANCING_ADMIN_BR_CREDIT_SUPERVISOR]: CreditApprovalStepType.CREDIT_SUPERVISOR_APPROVAL,
  [RoleNames.FINANCING_ADMIN_BR_CREDIT_MANAGER]: CreditApprovalStepType.CREDIT_MANAGER_APPROVAL,
  [RoleNames.FINANCING_ADMIN_BR_COMMERCIAL_DIRECTOR]: CreditApprovalStepType.COMMERCIAL_DIRECTOR_APPROVAL,
  [RoleNames.FINANCING_ADMIN_BR_FINANCE_DIRECTOR]: CreditApprovalStepType.FINANCE_DIRECTOR_APPROVAL
};
